<template>
  <div>
    <v-flex>
      <v-snackbar
        v-model="dialog.snackbar"
        top
        right
        color="#ff64ad">
        <span class="body-1 font-weight-light white--text"
          v-html="message.success">
        </span>

        <template v-slot:action="{ attrs }">
          <v-btn
            class="body-1 font-weight-bold text-capitalize"
            color="white"
            icon
            v-bind="attrs"
            @click="dialog.snackbar = false">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </template>
      </v-snackbar>

      <v-dialog v-model="dialog.zoom"
        @keydown.esc="dialog.zoom = false"
        :fullscreen="dialog.fullscreen"
        width="1000"
        persistent
        scrollable>
        <v-card class="border-radius pa-2">
          <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
            <v-avatar size="35">
              <v-img
                contain
                width="30"
                height="30"
                alt="vuetify"
                :src="require('@/assets/logo/favicon.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>

            <span class="mt-1 ml-1">
              Swafoto
            </span>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#ff64ad">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.zoom = false"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>

          <v-divider class="mx-4 mt-3 mb-2"/>

          <v-card-text v-if="Object.keys(detail).length > 0"
            class="pt-2 pa-4">
            <v-card
              flat
              style="border-radius: 10px;">
              <v-img
                contain
                min-height="750"
                alt="vuetify"
                gradient="to bottom, rgba(0, 0, 0, .1), rgba(0, 0, 0, .5)"
                :src="detail.image">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog.form"
        @keydown.esc="dialog.form = false"
        :fullscreen="dialog.fullscreen"
        width="500"
        persistent
        scrollable>
        <v-card class="border-radius pa-2">
          <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
            <v-avatar size="35">
              <v-img
                contain
                width="30"
                height="30"
                alt="vuetify"
                :src="require('@/assets/logo/favicon.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>

            <span class="mt-1 ml-1">
              Reset Password
            </span>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#ff64ad">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.form = false"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>

          <v-divider class="mx-4 mt-3 mb-2"/>

          <v-card-text 
            class="pt-2 body-1 line-text-second">
            <div
              class="font-weight-light black---text mb-2">
              Apakah Anda yakin mereset password akun <b>{{ detail.fullname }}</b> ?
            </div>

            <div 
              class="font-italic font-weight-light orange--text">
              *Jika Anda mereset password, maka password akan di default oleh sistem menjadi <b>123456</b>
            </div>
          </v-card-text>

          <v-divider class="mx-4 mb-3 mt-0"/>

          <v-card-actions>
            <v-spacer/>

            <v-btn
              color="#ff64ad"
              elevation="0"
              class="body-2 font-weight-bold text-capitalize white--text"
              :disabled="process.form"
              :loading="process.form"
              v-on:keyup.enter="save()"
              @click="save()">
              <v-icon small class="mr-1">mdi-check-bold</v-icon>
              Simpan
            </v-btn>

            <v-btn
              outlined
              class="body-2 font-weight-bold text-capitalize red--text"
              :disabled="process.form"
              @click="dialog.form = false">
              <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
              Batal
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <section>
        <v-row v-if="process.load && Object.keys(detail).length < 1">
          <v-col 
            cols="12"
            md="3"
            class="pb-0">
            <v-skeleton-loader
              type="image, article, list-item-three-line">
            </v-skeleton-loader>
          </v-col>

          <v-col 
            cols="12"
            md="9"
            class="pb-0">
            <v-skeleton-loader
              type="article, list-item-three-line, article, list-item-three-line, article, article, list-item-three-line">
            </v-skeleton-loader>
          </v-col>
        </v-row>

        <div v-if="!process.load && Object.keys(detail).length > 0"
          class="pb-0">
          <v-row>
            <v-col 
              cols="12"
              md="3"
              class="pb-0">
              <div @click="$router.go(-1)"
                class="d-flex align-center color-first cursor-pointer mb-4">
                <v-icon color="#ff64ad">mdi-arrow-left-thick</v-icon>
            
                <span class="body-1 ml-1">
                  Kembali
                </span>
              </div>

              <v-card
                flat
                class="mb-2"
                style="border-radius: 10px;">
                <v-img
                  contain
                  min-height="250"
                  alt="vuetify"
                  gradient="to bottom, rgba(0, 0, 0, .1), rgba(0, 0, 0, .5)"
                  :src="detail.image">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        indeterminate 
                        color="#ff64ad">
                      </v-progress-circular>
                    </v-row>
                  </template>

                  <v-icon 
                    @click="dialog.zoom = true"
                    class="cursor-pointer pa-2"
                    size="30"
                    color="white"
                    style="position: absolute;
                          top: 0px;
                          right: 0px;">
                    mdi-fullscreen
                  </v-icon>

                  <div
                    class="title pa-4 white--text"
                    style="position: absolute;
                          bottom: 0px;">
                    Swafoto
                  </div>
                </v-img>
              </v-card>

              <v-card
                flat>
                <v-card-text
                  class="body-2 font-italic font-weight-light px-0 line-text-second mb-1"
                  style="opacity: 60%;">
                  *Untuk mereset password akun, silahkan klik tombol dibawah ini maka akun tersebut akan direset password dengan "<b>123456</b>".
                </v-card-text>

                <v-card-text
                  class="pa-0">
                  <v-btn
                    @click="dialog.form = true"
                    block
                    elevation="0"
                    color="orange"
                    class="body-2 font-weight-bold text-capitalize white--text d-flex align-center">
                    <v-icon>mdi-shield-key</v-icon>

                    <v-spacer />

                    <span>
                      Reset Password
                    </span>
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col 
              cols="12"
              md="9"
              class="pb-0">
              <v-card
                flat
                class="ml-3">
                <v-card-title
                  class="text-h5 font-weight-bold px-0 mt-4 mb-1">
                  {{ detail.fullname }}
                </v-card-title>

                <v-card-subtitle
                  class="body-1 font-weight-light red--text px-0 d-flex align-center mb-4">
                  <v-icon color="red" class="mr-1">mdi-account-cancel</v-icon>

                  {{ detail.update_datetime | date }}
                </v-card-subtitle>

                <v-card-text
                  class="px-0">
                  <v-divider
                    style="border: 3px solid #ff64ad;
                        border-radius: 50px;
                        width: 100px;" />

                  <div
                    class="body-1 font-weight-bold black--text my-2">
                    Data Pribadi
                  </div>
                  
                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      KK (Kartu Keluarga)
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0">
                      : {{ detail.kk === '' ? '-' : detail.kk }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      NIK
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0">
                      : {{ detail.nik === '' ? '-' : detail.nik }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      Email
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0">
                      : {{ detail.email === '' ? '-' : detail.email }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-7">
                    <v-col
                      cols="3"
                      class="py-0">
                      Telepon
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0">
                      : {{ detail.phone === '' ? '-' : detail.phone }}
                    </v-col>
                  </v-row>

                  <v-divider
                    style="border: 3px solid #ff64ad;
                        border-radius: 50px;
                        width: 100px;" />

                  <div
                    class="body-1 font-weight-bold black--text my-2">
                    Alamat Lengkap
                  </div>

                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      Dukuh
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0">
                      : {{ detail.dukuh === '' ? '-' : detail.dukuh }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      RT / RW
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0">
                      : {{ detail.rt === '' ? '-' : detail.rt }} / {{ detail.rw === '' ? '-' : detail.rw }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      Kelurahan
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0">
                      : {{ detail.kelurahan_name === '' ? '-' : detail.kelurahan_name }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-7">
                    <v-col
                      cols="3"
                      class="py-0">
                      Kecamatan
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0">
                      : {{ detail.kecamatan_name === '' ? '-' : detail.kecamatan_name }}
                    </v-col>
                  </v-row>

                  <v-divider
                    style="border: 3px solid #ff64ad;
                        border-radius: 50px;
                        width: 100px;" />

                  <div
                    class="body-1 font-weight-bold black--text my-2 mb-1">
                    Hak Akses
                  </div>

                  <div
                    class="mb-3">
                    Berikut adalah hak akses untuk admin {{ detail.fullname }}:
                  </div>

                  <div
                    v-for="(item, index) in detail.role_access.split(',')"
                    :key="index"
                    class="d-flex align-center mb-2 text-capitalize">
                    <v-icon small color="green">mdi-check-circle-outline</v-icon>
                    
                    <span class="ml-1">
                      {{ item.replace(/_/g, ' ') }}
                    </span>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </section>
    </v-flex>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        dialog: {
          snackbar: false,
          fullscreen: false,
          zoom: false,
          form: false
        },
        detail: {},
        form: {
          id: '',
          new_password: '123456'
        },
        process: {
          load: false,
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {

    },
    computed: {
      
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        await get(`user_admin/detail`, { params })
        .then((response) => {
          let res = response.data

          if (res.code === 200) {
            this.process.load = false
            
            this.detail = res.data

            this.form.id = this.detail.id
          }
        })
      },
      async save () {
        this.message.error = ''

        this.process.form = true

        // SAVE TO REST API
        await post('user_admin/update_password', {
          data: this.form
        })
        .then(response => {
          let res = response.data

          this.process.form = false

          if (res.code === 200) {
            this.dialog.form = false

            this.dialog.snackbar = true

            this.message.success = res.message

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>